import cloneDeep from 'lodash/cloneDeep';
import DROPPABLE_LOCATION_IDS from './droppableLocationIds';
import { generateDroppableLocationIdWithSection } from './generateDroppableLocationIdWithSection';
import { layoutTypeToDroppableLocationIdMap } from './generateDroppableLocationSetForSection';

function retrieveLayoutType(locationId) {
  const droppableLocationKeys = Object.keys(layoutTypeToDroppableLocationIdMap);
  let layoutType;
  let analysisCol;
  droppableLocationKeys.forEach((key) => {
    const locIdsOfKey = layoutTypeToDroppableLocationIdMap[key];
    const exists = locIdsOfKey.findIndex((locId) => locId === locationId);
    if (exists > -1) {
      layoutType = key;
      analysisCol = exists;
    }
  });
  return Number.isInteger(parseInt(layoutType, 10))
    ? { layoutType: parseInt(layoutType, 10), analysisCol }
    : { layoutType: 1, analysisCol: 0 };
}

export default function getSectionsFromDroppableLocations(
  droppableLocations,
  libraryItemMap
) {
  const sourceTray = droppableLocations[DROPPABLE_LOCATION_IDS.SOURCE_TRAY_ID];

  const nonLaidOutLibraryItems = sourceTray.libraryItemIds.map((id, index) => {
    const cloned = cloneDeep(libraryItemMap[id]);
    if (cloned.analysisColumn) delete cloned.analysisColumn;
    cloned.order = index + 1;
    return cloned;
  });

  const droppableLocationIds = Object.values(DROPPABLE_LOCATION_IDS).filter(
    (value) => value !== DROPPABLE_LOCATION_IDS.SOURCE_TRAY_ID
  );
  const numberOfAreaIds = droppableLocationIds.length;

  const sections = [];
  let sectionNumber = 1;
  let sectionsRemain = true;

  while (sectionsRemain) {
    const section = {
      order: sectionNumber,
    };
    let itemsInSection = [];
    const droppableLocationIdsExist = droppableLocationIds.map(() => false);
    for (
      let locationIdIndex = 0;
      locationIdIndex < numberOfAreaIds;
      locationIdIndex += 1
    ) {
      const locationId = droppableLocationIds[locationIdIndex];
      if (!Array.isArray(locationId) && typeof locationId === 'string') {
        const locationIdWithSection = generateDroppableLocationIdWithSection(
          locationId,
          sectionNumber
        );
        const currentDroppableLocation =
          droppableLocations[locationIdWithSection];
        if (currentDroppableLocation) {
          droppableLocationIdsExist[locationIdIndex] = true;
          const { layoutType, analysisCol } = retrieveLayoutType(locationId);
          section.layoutType = layoutType;

          const libraryItemIdsInDroppableLocation =
            currentDroppableLocation.libraryItemIds;
          const libraryItemsInDroppableLocation =
            libraryItemIdsInDroppableLocation.map((id) => libraryItemMap[id]);
          const itemsWithColumnAndOrder = libraryItemsInDroppableLocation.map(
            (item, index) => {
              item.analysisColumn = analysisCol + 1;
              item.order = index + 1;
              return item;
            }
          );
          itemsInSection = [...itemsInSection, ...itemsWithColumnAndOrder];
        }
      } else {
        // eslint-disable-next-line no-loop-func
        locationId.forEach((locId, locIndex) => {
          const locIdWithSection = generateDroppableLocationIdWithSection(
            locId,
            sectionNumber
          );
          const currentDroppableLocation = droppableLocations[locIdWithSection];
          if (currentDroppableLocation) {
            droppableLocationIdsExist[locationIdIndex] = true;
            const { layoutType } = retrieveLayoutType(locId);
            section.layoutType = layoutType;
            const libraryItemIdsInDroppableLocation =
              currentDroppableLocation.libraryItemIds;
            const libraryItemsInDroppableLocation =
              libraryItemIdsInDroppableLocation.map((id) => libraryItemMap[id]);
            const itemsWithColumnAndOrder = libraryItemsInDroppableLocation.map(
              (item, index) => {
                item.analysisColumn = locIndex + 1;
                item.order = index + 1;
                return item;
              }
            );
            itemsInSection = [...itemsInSection, ...itemsWithColumnAndOrder];
          }
        });
      }
    }

    if (!droppableLocationIdsExist.includes(true)) {
      sectionsRemain = false;
    }

    if (sectionsRemain) {
      section.items = itemsInSection;
      sections.push(section);
      sectionNumber += 1;
    }
  }

  return {
    nonLaidOutLibraryItems,
    sections,
  };
}
